module.exports = __webpack_public_path__ + "static/media/nReportBugIcon.8fdb484c.svg";